import "./CreateWidgetComponent.scss";
import template from "./CreateWidgetComponent.html";
import {IComponentOptions} from "angular";
import {AddDashboardWidgetService} from "../../../dialog/add-widget/service/AddDashboardWidgetService";
import {Observable} from "rxjs";
import {defaultWidgetOptions} from "../../../models/WidgetType";
import {ComponentCallback} from "../../../../../types/AngularJS";

export const CreateWidget = "tfCreateWidget";

export function createWidget(): IComponentOptions {
    return {
        template,
        bindings: {
            onCreate: "&"
        },
        controllerAs: "ctrl",
        controller: CreateWidgetComponentController
    };
}

export class CreateWidgetComponentController {

    /** @output */
    public readonly onCreate: ComponentCallback;

    /** @ngInject */
    public constructor(private readonly addDashboardWidgetService: AddDashboardWidgetService) {

    }

    public addWidget() {
        const result = this.addDashboardWidgetService.open();
        Observable.fromPromise(result)
                  .map(defaultWidgetOptions)
                  .subscribe((widget) => this.onCreate({widget}));
    }
}
